<template>
    <section id="gifts">
        <h2 ref="giftsRef">Gifts</h2>
        <p class="mb-4">
            We are truly honored to have you celebrate our special day with us.
            Your presence is more than enough, but if you would like to give us a gift,
            we would be overjoyed with a contribution of any amount towards our honeymoon fund.
            This will be going towards our dream honeymoon to Victoria Falls and Botswana.
        </p>

        <div class="gift-info">
            <div class="honeymoon-fund">
                <h4 class="mb-2">Honeymoon Fund</h4>
            <div class="bank-details mt-4">
                    <p>
                        <strong>Account Holder's Name:</strong> James Thomson<br>
                        <strong>Bank Name:</strong> Nedbank<br>
                        <strong>Account Number:</strong> 1313870544<br>
                        <strong>Branch Code:</strong> 198765<br>
                        <strong>Reference:</strong> Your Name
                    </p>
                    <p class="mt-4" style="font-size: 0.95em; color: #666;">
                        Please use your name as the reference so we can thank you!
                    </p>
            </div>
            </div>
        </div>
	</section>
</template>

<script>
export default {
    name: "GiftsSection",
}
</script>

<style scoped>
.registry-links {
	margin-top: 1rem;
}

.registry-link {
	color: #1976d2;
	text-decoration: none;
	font-weight: 500;
	transition: color 0.3s ease;
}

.registry-link:hover {
	color: #1565c0;
	text-decoration: underline;
}

.gift-info {
	margin-top: 2rem;
}

.registry-section, .honeymoon-fund, .charitable-donations {
	padding: 1.5rem;
	border: 1px solid #e0e0e0;
	border-radius: 8px;
	background-color: #fafafa;
}
</style>